var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconAccessibility48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2241_9330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 5.33554C34.3095 5.33554 42.6671 13.6931 42.6671 24.0027C42.6671 34.3123 34.3095 42.6698 23.9999 42.6698C13.6903 42.6698 5.33276 34.3123 5.33276 24.0027C5.33276 13.6931 13.6903 5.33554 23.9999 5.33554ZM15.2537 16.5358C14.3937 16.5358 13.6965 17.2265 13.6965 18.0784C13.6965 19.0444 14.4322 19.8548 15.402 19.957L20.144 20.4568H20.8383V26.8469L18.1282 35.627C17.8719 36.4572 18.3437 37.3361 19.1819 37.5899C20.0201 37.8437 20.9074 37.3764 21.1637 36.5462L23.9465 27.5307H24.1483L26.9311 36.5462C27.1874 37.3764 28.0747 37.8437 28.9129 37.5899C29.7511 37.3361 30.2229 36.4572 29.9666 35.627L27.1867 26.6209V20.4568H27.881L32.623 19.957C33.5928 19.8548 34.3286 19.0444 34.3286 18.0784C34.3286 18.0288 34.3262 17.9792 34.3213 17.9299C34.2385 17.082 33.4774 16.4611 32.6213 16.5431L27.2363 17.0591H20.7887L15.4037 16.5431C15.3538 16.5383 15.3038 16.5358 15.2537 16.5358ZM24.0125 10.7762C22.6977 10.7762 21.6319 11.8319 21.6319 13.1342C21.6319 14.4364 22.6977 15.4921 24.0125 15.4921C25.3273 15.4921 26.3931 14.4364 26.3931 13.1342C26.3931 11.8319 25.3273 10.7762 24.0125 10.7762Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0125 15.4921C25.3272 15.4921 26.3931 14.4364 26.3931 13.1342C26.3931 11.8319 25.3272 10.7762 24.0125 10.7762C22.6977 10.7762 21.6318 11.8319 21.6318 13.1342C21.6318 14.4364 22.6977 15.4921 24.0125 15.4921Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1481 27.5307H23.9463L21.1635 36.5462C20.9072 37.3764 20.02 37.8437 19.1817 37.5899C18.3435 37.336 17.8718 36.4572 18.128 35.627L20.8382 26.8469V20.4568H20.1438L15.4019 19.957C14.432 19.8548 13.6963 19.0444 13.6963 18.0784C13.6963 17.2265 14.3935 16.5358 15.2536 16.5358C15.3036 16.5358 15.3537 16.5383 15.4035 16.5431L20.7886 17.0591H27.2361L32.6212 16.5431C33.4772 16.4611 34.2384 17.082 34.3212 17.9299C34.326 17.9792 34.3284 18.0288 34.3284 18.0784C34.3284 19.0444 33.5927 19.8548 32.6228 19.957L27.8809 20.4568H27.1865V26.6209L29.9664 35.627C30.2227 36.4572 29.7509 37.336 28.9127 37.5899C28.0745 37.8437 27.1872 37.3764 26.931 36.5462L24.1481 27.5307Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2241_9330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.00268555)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconAccessibility48);
export default __webpack_public_path__ + "static/media/pictogramBeaconAccessibility48.6fece3703b052eccef25d4f599366d19.svg";
export { ForwardRef as ReactComponent };